import React from "react";
import Ambiente from "../images/ambiente.png";
import FondoAmbiente from "../images/fondoambiente.png";
import FondoAmbiente2 from "../images/fondoambiente2.png";
import Boletin from "../images/boletin.png";
import NotaAmbiente from "../images/notaambiental.png";

import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import TitleSmall from "../components/TitleSmall";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  contentLamina2: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
    background: theme.palette.secondary.main,
    padding: "2em",
  },
  actividadFondo: {
    backgroundImage: "url(" + FondoAmbiente + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 400,
    width: "100%",
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("xs")]: {
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
      "& p": {
        maxWidth: "100%",
      },
    },
  },
  actividadFondo2: {
    backgroundImage: "url(" + FondoAmbiente2 + ")",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    minHeight: 800,
    height: "auto",
    width: "100%",
    padding: 10,
    marginTop: 40,

    "& p": {
      lineHeight: 1.5,
      maxWidth: 400,
    },
    marginBottom: "4em",
    [theme.breakpoints.down("md")]: {
      "& p": {
        maxWidth: "100% !important",
      },
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: 1200,
      backgroundSize: "100% auto",
      backgroundPosition: "bottom",
      "& p": {
        maxWidth: "100%",
      },
    },
  },
  actividad: {
    background: "#6a2c9138",
    border: "6px solid " + theme.palette.purple.main,
    "& p": {
      marginLeft: "1em",
    },
    marginBottom: "4em",
  },
  options: {
    borderBottom: "1px solid #ccc",
  },
  option: {
    color: theme.palette.blue.main,
    textAlign: "right",
  },
  actividadContent: {
    maxWidth: 800,
  },
  bloqueRojo: {
    background: theme.palette.primary.main,
    color: "#fff",
    padding: "0.5em 1em",
    maxWidth: 500,
    marginRight: "2em",
  },
  root: {
    textAlign: "center",
    "& h1": {
      textAlign: "left",
    },
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
}));

const Lamina2 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 10: El cuidado del ambiente"
        meta={[
          {
            property: "og:title",
            content: "Lámina 10: El cuidado del ambiente",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Debemos comprender la importancia de convivir respetuosamente con el ambiente.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="10" color="primary" />
      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={6} md={6} xs={12}>
            <Title title="EL CUIDADO DEL AMBIENTE" color="primary" />
            <p>
              Si bien los seres humanos estamos constantemente transformando
              nuestro territorio, es importante saber que nuestras acciones
              tienen un impacto sobre el espacio en el que vivimos. Debemos
              comprender la importancia de convivir respetuosamente con el
              ambiente.
            </p>
            <p style={{ color: "#00a77e" }}>
              <strong>
                Todos podemos hacer algo. Podemos contribuir en nuestra
                localidad con acciones como la siembra y el cuidado de árboles.
              </strong>
            </p>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <img src={Ambiente} alt="Cuidado del ambiente" />
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <TitleSmall title="UN PROBLEMA EN LA AMAZONÍA" color="primary" />
        <p>
          En nuestra selva existe el problema de la deforestación. Al talar
          excesivamente los árboles afectamos a los animales y las plantas de la
          zona.
        </p>
        <p>
          Además, se realizan otras actividades productivas que podrían generar
          contaminación del agua, el suelo y el aire si es que no respetan las
          normas de conservación. Los terrenos al ser contaminados podrían, por
          ejemplo, volverse improductivos para la agricultura.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo}>
          <div className={classes.bloqueRojo}>
            <strong>
              ¿Cómo crees que podría afectarnos esto en la Amazonía y en las
              distintas regiones del país? Responde de manera escrita o graba un
              audio o video con tu respuesta.
            </strong>
          </div>
        </div>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <div className={classes.actividadFondo2}>
          <Grid container className={classes.root} spacing={2} justify="center">
            <Grid item lg={8} md={8} xs={12}>
              <Actividad color="primary" />
              <p>
                <strong>
                  Observa la imagen y responde de forma oral o escrita.
                </strong>
              </p>
              <ul>
                <li>¿Qué está pasando en la imagen?</li>
                <li>¿Dónde están?</li>
                <li>¿Qué personajes aparecen?</li>
                <li>¿Qué hace cada uno de ellos?</li>
              </ul>
              <p>
                <strong>
                  Ahora imagina que estás redactando una nota en el periódico y
                  completa el texto.
                </strong>
              </p>
            </Grid>
            <Grid item lg={4} md={4} xs={12}>
              <img
                src={Boletin}
                style={{ maxWidth: 340, marginLeft: -80 }}
                alt="Nota"
              />
              <p>
                Contribuye con tus acciones. Una forma de prevenir y reducir la
                contaminación en tu localidad es reusar materiales. Con ayuda de
                un adulto, puedes, por ejemplo, cortar botellas de plástico para
                usarlas como macetas. ¿Qué otros usos puedes dar a estas
                botellas
              </p>
            </Grid>
          </Grid>
          <Grid container className={classes.root} spacing={2} justify="center">
            <Grid item lg={6} md={6} xs={12}>
              <img src={NotaAmbiente} style={{ maxWidth: 340 }} alt="Nota" />
            </Grid>
            <Grid item lg={6} md={6} xs={12}></Grid>
          </Grid>
        </div>
      </Container>
      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-10.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          color="primary"
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 10: El cuidado del ambiente'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Recursos naturales del Perú"
        anteriorEnlace="/lamina-1-9"
        siguiente="Los medios de transporte"
        siguienteEnlace="/lamina-1-11"
      />
    </>
  );
};

export default Lamina2;
